import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, computed, onActivated } from "vue";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { ILostFoundDetail } from "@/domain/entities/bbs/lostFound/lostFoundDetail.types";
import { useBbsStore } from "@/stores/bbsStore";
import {
  LostFoundStatusCode,
  PROVIDE_KEY_REMOVE_LOADING_IMAGE,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_LOADING_IMAGE,
  RemoveLoadingImage,
  RouterName,
  ShowErrorModal,
  ShowLoadingImage,
} from "@/types";
import { useRoute } from "vue-router";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import router from "@/router";
import Modal from "@/components/shared/modal/base/Modal.vue";
import DOMPurify from "dompurify";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "LostDetail",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showLoadingImage = inject(
  PROVIDE_KEY_SHOW_LOADING_IMAGE
) as ShowLoadingImage;
const removeLoadingImage = inject(
  PROVIDE_KEY_REMOVE_LOADING_IMAGE
) as RemoveLoadingImage;

const route = useRoute();
const uid = route.params.uid?.toString();

const bbsStore = useBbsStore();
const lostFoundDetail = ref<ILostFoundDetail>();
const contentWrapper = ref<HTMLElement>();

const lostFoundStatusCodeMap: Record<string, string> = {
  [LostFoundStatusCode.STORE]: "store",
  [LostFoundStatusCode.RECOVE]: "recover",
  [LostFoundStatusCode.DISCAR]: "discard",
};

const lostNoteHtml = computed(() => {
  const lostNote = lostFoundDetail.value?.lostNote;
  return lostNote ? lostNote.replace(/\n/g, "<br />") : "";
});

const getLostFoundDetail = async () => {
  showLoadingImage();
  const result = await bbsStore.getLostFoundDetail(uid);
  removeLoadingImage();

  if (!result.isSuccess) {
    showErrorModal(
      "분실물 상세 오류",
      result.errorMessage,
      result.resultCode,
      result.errorTime
    );
    return;
  }

  if (!result.data) return;

  lostFoundDetail.value = result.data;
};

const goBack = () => {
  router.currentRoute.value.meta.willGoBack = true;
  router.back();
};

const goToLostEdit = () => {
  if (!lostFoundDetail.value?.uid) {
    showErrorModal(
      "분실물 식별자 확인불가",
      "분실물 정보를 확인할 수 없습니다."
    );
    return;
  }

  router.push({
    name: RouterName.LostEdit,
    params: { uid: lostFoundDetail.value?.uid ?? "" },
  });
};

const shouldShowLostItemDeleteModal = ref(false);
const toggleShowLostItemDeleteModal = (show: boolean) => {
  shouldShowLostItemDeleteModal.value = show;
};

const deleteLostItem = async () => {
  showLoadingImage();
  const result = await bbsStore.deleteLostFoundDetail(
    lostFoundDetail.value?.uid ?? ""
  );
  removeLoadingImage();

  if (!result.isSuccess) {
    showErrorModal(
      "분실물 신고삭제 오류",
      result.errorMessage,
      result.resultCode,
      result.errorTime
    );
    return;
  }

  router.back();
};

onActivated(() => {
  getLostFoundDetail();
});

const __returned__ = { showErrorModal, showLoadingImage, removeLoadingImage, route, uid, bbsStore, lostFoundDetail, contentWrapper, lostFoundStatusCodeMap, lostNoteHtml, getLostFoundDetail, goBack, goToLostEdit, shouldShowLostItemDeleteModal, toggleShowLostItemDeleteModal, deleteLostItem, Page, NavigationBar, get LostFoundStatusCode() { return LostFoundStatusCode }, FooterButton, Modal, get DOMPurify() { return DOMPurify }, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})